// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"822cec23","453":"51b20bab","667":"a5476132"}[chunkId] + ".chunk.js";
};